export const posRoutes = [
  {
    name: 'posConfig',
    path: '/pos-config',
    component: () => import('@/modules/pos/views/PosConfig.vue'),
    meta: {
      locationTypes: ['location', 'singleLocation']
    }
  },
  {
    name: 'fastModeConfig',
    path: '/fast-mode-config',
    component: () => import('@/modules/pos/views/FastModeConfig.vue'),
    meta: {
      locationTypes: ['location', 'singleLocation']
    }
  }
]
